import cryptoJs from "crypto-js";

/**
 * 加密
 *
 * @param keyWord
 * @param word
 * @returns {*}
 */
export const encrypt = (keyWord, word) => {
  if (keyWord.length !== 16 && keyWord.length !== 32) {
    console.error("密钥必须是16位或32位");
    return null;
  }
  const key = cryptoJs.enc.Utf8.parse(keyWord);
  const src = cryptoJs.enc.Utf8.parse(word);
  const encrypted = cryptoJs.AES.encrypt(src, key, {
    mode: cryptoJs.mode.ECB,
    padding: cryptoJs.pad.Pkcs7
  });
  return encrypted.toString();
};

/**
 * 解密
 * @param keyWord
 * @param word
 * @returns {string|null}
 */
export const decrypt = (keyWord, word) => {
  if (keyWord.length !== 16 && keyWord.length !== 32) {
    console.error("密钥必须是16位或32位");
    return null;
  }
  const key = cryptoJs.enc.Utf8.parse(keyWord);
  const decrypt = cryptoJs.AES.decrypt(word, key, {
    mode: cryptoJs.mode.ECB,
    padding: cryptoJs.pad.Pkcs7
  });
  return cryptoJs.enc.Utf8.stringify(decrypt).toString();
};
